import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import isBetween from "dayjs/plugin/isBetween";
import "dayjs/locale/ko";  // 한국어 로케일을 가져옵니다.

dayjs.extend(relativeTime);
dayjs.extend(isBetween);
// dayjs.locale("ko");

const DATE_FORMAT = (date, format) => {
    if (format === "long") {
        return dayjs(date).format("YYYY-MM-DD HH:mm");
    } else if (format === "short") {
        return dayjs(date).format("YY-MM-DD");
    } else {
        return dayjs(date).format("YYYY-MM-DD");
    }
};

const GET_TIME_AGO = (date) => {
    return dayjs(date).fromNow();
};

const DATE_DIFF = (start_date, end_date) => {
    return dayjs(end_date).diff(dayjs(start_date), "day");
};

const MONTH_DIFF = (start_date, end_date) => {
    return dayjs(end_date).diff(dayjs(start_date), "month");
};

const IS_DATE_IN_RANGE = (start_date, end_date, month_pay_date) => {
    const startDay = dayjs(start_date).date();
    const endDay = dayjs(end_date).date();

    for (let day = startDay; day <= endDay; day++) {
        if (day === month_pay_date) {
            return true;
        }
    }

    return false;
};

const GET_AD_STATUS = (start_date, end_date) => {
    const today = dayjs();
    const startDate = dayjs(start_date);
    const endDate = dayjs(end_date);

    if (today.isBefore(startDate)) {
        return "<span class='badge badge-info-lighten'>광고 예정</span>";
    } else if (today.isAfter(endDate)) {
        return "<span class='badge badge-danger-lighten'>광고 종료</span>";
    } else {
        return "<span class='badge badge-success-lighten'>광고 중</span>";
    }
}

export {
    DATE_FORMAT,
    GET_TIME_AGO,
    DATE_DIFF,
    MONTH_DIFF,
    IS_DATE_IN_RANGE,
    GET_AD_STATUS
};